export default function getSite(){
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookies = decodedCookie.split(";");
    const name = "SiteSettings";
    let site;
    for (let c of cookies) {
        while (c.charAt(0) === " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            site = c.substring(13);
        }
    }
    return site;
}